'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./index.scss');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _ConfigGlobal = require('../config/ConfigGlobal');

var _ConfigGlobal2 = _interopRequireDefault(_ConfigGlobal);

var _UtilApi = require('../utils/UtilApi');

var _UtilOptions = require('../utils/UtilOptions');

var _BaseCombobox2 = require('./BaseCombobox');

var _BaseCombobox3 = _interopRequireDefault(_BaseCombobox2);

var _AsyncPaginate = require('./utils/AsyncPaginate');

var _AsyncPaginate2 = _interopRequireDefault(_AsyncPaginate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IDAsyncCombobox = function (_BaseCombobox) {
  (0, _inherits3.default)(IDAsyncCombobox, _BaseCombobox);

  function IDAsyncCombobox(props) {
    (0, _classCallCheck3.default)(this, IDAsyncCombobox);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IDAsyncCombobox.__proto__ || (0, _getPrototypeOf2.default)(IDAsyncCombobox)).call(this, props));

    _this._loadOptions = function (search, prevOptions) {
      var options = _this.state.options;

      var filteredOptions = void 0;
      var slicedOptions = void 0;
      var _length = prevOptions === undefined ? 0 : prevOptions.length;
      if (!search) {
        filteredOptions = options;
      } else {
        var searchLower = _this.boDauTiengViet(search);
        filteredOptions = _lodash2.default.filter(options, function (obj) {
          return _lodash2.default.includes(_this.boDauTiengViet(obj.label), searchLower);
        });
      }
      var hasMore = filteredOptions ? filteredOptions.length > _length + 10 : false;

      if (filteredOptions) {
        if (filteredOptions.length < _length) {
          slicedOptions = filteredOptions.slice(0, 10);
        } else {
          slicedOptions = filteredOptions.slice(_length, _length + 10);
        }
      } else {
        slicedOptions = [];
      }

      return {
        options: slicedOptions,
        hasMore: hasMore
      };
    };

    _this.handleChange = function (value) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly;

      if (disabled || readOnly) {
        return;
      }
      var val = _this.convertValue(value);
      _this.setValue(val);
    };

    _this.state = {
      value: _this.convertValue(!_this.checkIsEmptyOrNull(props.value) ? props.value : props.defaultValue),
      options: (0, _UtilApi.getProxy)(props) ? [] : _this.convertData(props.options)
    };
    _this.loadOptions = _lodash2.default.debounce(_this._loadOptions, 100);
    _this.dataTestID = 'async-combobox';
    return _this;
  }

  (0, _createClass3.default)(IDAsyncCombobox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var proxy = (0, _UtilApi.getProxy)(this.props);
      if (proxy) {
        this.loadData(proxy, function (options) {
          _this2.setState({
            options: options
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          isMulti = _props.isMulti,
          className = _props.className,
          style = _props.style,
          disabled = _props.disabled,
          visibleIcon = _props.visibleIcon,
          isClearable = _props.isClearable,
          isSearchable = _props.isSearchable,
          iconCls = _props.iconCls,
          iconType = _props.iconType;
      var _state = this.state,
          value = _state.value,
          options = _state.options;

      var _value = (0, _UtilOptions.getCustomValueCombo)(value, options);
      return _react2.default.createElement(
        'div',
        {
          'data-testid': this.getDataTestId(),
          className: (0, _classnames2.default)('body-wrap', className, { 'input-disabled': disabled }),
          style: style
        },
        _react2.default.createElement(_AsyncPaginate2.default, {
          selectRef: function selectRef(ref) {
            _this3.ref = ref;
          },
          value: _value,
          loadOptions: this._loadOptions,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: '',
          isMulti: isMulti,
          visibleIcon: visibleIcon,
          isClearable: disabled === true ? false : isClearable,
          isSearchable: isSearchable,
          iconCls: iconCls,
          iconType: iconType || _lodash2.default.get(_ConfigGlobal2.default, 'iconType.select'),
          onInputChange: this.onInputChange,
          dataTestID: this.getDataTestId() + '-input'
        }),
        this.renderPlaceholder()
      );
    }
  }]);
  return IDAsyncCombobox;
}(_BaseCombobox3.default);

exports.default = IDAsyncCombobox;


IDAsyncCombobox.defaultProps = (0, _assign2.default)({}, _BaseCombobox3.default.defaultProps, {
  iconCls: "",
  iconType: "caret-down",
  visibleIcon: true,
  isSearchable: true,
  isClearable: true,
  placeholder: 'Select...'
});